import { Component, ElementRef, Renderer2 } from '@angular/core';
import { HeroComponent } from '../../shared/hero/hero.component';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { FirestoreService } from '../../../services/firestore/firestore.service';
import { JobDto } from '../../../models/job-dto';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AuthServiceService } from '../../../services/authService/auth-service.service';
import { Application } from '../../../models/application';
import { Timestamp } from 'firebase/firestore';
import { ApplicationService } from '../../../services/application/application.service';
import { SharedService } from '../../../services/shared/shared.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotificationService } from '../../../services/notification/notification.service';
import { NotificationRequest } from '../../../models/notification-request';
import { EmailService } from '../../../services/email/email.service';

@Component({
  selector: 'app-application',
  imports: [HeroComponent, FormsModule, RouterLink, CommonModule],
  templateUrl: './application.component.html',
  styleUrl: './application.component.css'
})
export class ApplicationComponent {
  jobDetails: JobDto = {
    category: '',
    text: '',
    title: '',
    id: ''
  };
  id: any;
  selectedFile: File | null = null;
  coverLetter: string = '';
  userUid: any;
  userIds: any;
  adminEmails: any;

  constructor(
    private route: Router,
    private router: ActivatedRoute,
    private firstoreService: FirestoreService,
    private authService: AuthServiceService,
    private firestoreService: FirestoreService,
    private applicationService: ApplicationService,
    private sharedService: SharedService,
    private spinner: NgxSpinnerService,
    private notificationSrvice: NotificationService,
    private emailService: EmailService
  ) { }

  ngOnInit() {
    this.id = this.router.snapshot.params['jobId'];
    this.firstoreService.getById("jobs", this.id).subscribe({
      next: res => {
        this.jobDetails = res;
        console.log(this.jobDetails);
      },
      error: err => {
        console.log(err);
      }
    });
    this.userUid = this.authService.getCurrentUserUid();
    console.log("Benutzer-ID:", this.userUid);

    this.firestoreService.getAdminUserIds().subscribe({
      next: res => this.userIds = res
    });
    this.firestoreService.getAdminsEmail().subscribe({
      next: res => this.adminEmails = res
    });
  }

  submitApplication() {
    if (!this.selectedFile) return;
    this.spinner.show();
    const request: Application = {
      userId: this.userUid,
      jobId: this.id,
      coverLetter: this.coverLetter,
      cvUrl: '',
      status: 'pending',
    };

    const filePath = `cvs/${Date.now()}_${this.selectedFile.name}`;

    this.firestoreService.uploadFile(filePath, this.selectedFile).subscribe({
      next: (url) => {
        request.cvUrl = url;

        this.applicationService.createApplication(request).subscribe({
          next: res => {
            this.sharedService.handleSuccess(
              "Bewerbung erfolgreich eingereicht!", // Title
              "Ihre Bewerbung wurde gesendet."      // Message
            );
            this.coverLetter = "";
            this.selectedFile = null;
            let request = new NotificationRequest();
            request.title = "Bewerbung erhalten";
            request.body = "Sie haben eine neue Bewerbung für die Stelle " + this.jobDetails.title + " erhalten.";
            request.type = "APPLICATION_RECEIVED";
            request.userIds = this.userIds;
            request.status = "UNREAD";
            this.notificationSrvice.saveNotification(request).subscribe({});
            let emailRequest = {
              to_name: "Towards Germany Admin",
              reply_to: this.adminEmails,
              subject: request.title,
              body: request.body
            };

            this.emailService.sendEmail(emailRequest);

            this.route.navigateByUrl("/Profile?tab=applications");
          },
          error: err => {
            this.sharedService.handleError(
              err,                                    // Error object
              "Bewerbungsfehler",                    // Title
              "Fehler beim Einreichen Ihrer Bewerbung." // Message
            );
          }
        });
      },
      error: (error) => {
        this.sharedService.handleError(
          error,                                    // Error object
          "Upload-Fehler",                         // Title
          "Fehler beim Hochladen Ihres Lebenslaufs. Bitte versuchen Sie es erneut." // Message
        );
      }
    });
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];

    if (file && file.type === 'application/pdf' && file.size <= 2 * 1024 * 1024) {
      this.selectedFile = file;
    } else {
      this.sharedService.handleError('Bitte laden Sie eine gültige PDF-Datei hoch (max. 2 MB).');
    }
  }
}